<div class="condition-instrument-container">
  <div class="header-container">
    <h5 class="header">Instrument</h5>
    <button class="menu-item" mat-flat-button color="accent">
      <div class="center" (click)="onAddInstrument()">+ Instrument</div>
    </button>
  </div>
  <div class="content">
    @if (this.instruments.length > 0) {
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="instruments-table mat-elevation-z3" style="width: 100%">
          <!-- Amount Column -->
          <ng-container matColumnDef="Amount">
            <th mat-header-cell *matHeaderCellDef class="column-amount">Amount</th>
            <td mat-cell *matCellDef="let element" class="column-amount">{{ element.amount | number }}</td>
          </ng-container>
          <!-- Type Column -->
          <ng-container matColumnDef="Type">
            <th mat-header-cell *matHeaderCellDef class="column-type">Type</th>
            <td mat-cell *matCellDef="let element" class="column-type">{{ element.type }}</td>
          </ng-container>
          <!-- Bank Column -->
          <ng-container matColumnDef="Bank">
            <th mat-header-cell *matHeaderCellDef class="column-bank">Bank</th>
            <td mat-cell *matCellDef="let element" class="column-bank">{{ element.bank }}</td>
          </ng-container>
          <!-- Instrument # Column -->
          <ng-container matColumnDef="Instrument #">
            <th mat-header-cell *matHeaderCellDef class="column-instrument-number">Instrument #</th>
            <td mat-cell *matCellDef="let element" class="column-instrument-number">
              @if (!element.instrumentNumber) {
                <app-no-data></app-no-data>
              }
              {{ element.instrumentNumber }}
            </td>
          </ng-container>
          <!-- Received Date Column -->
          <ng-container matColumnDef="Received Date">
            <th mat-header-cell *matHeaderCellDef class="column-received-date">Received Date</th>
            <td mat-cell *matCellDef="let element" class="column-received-date">
              {{ element.receivedDate | date: 'yyyy-MMM-dd' }}
            </td>
          </ng-container>
          <!-- Status Column -->
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef class="column-status">Status</th>
            <td mat-cell *matCellDef="let element" class="column-status">{{ getFormattedStatus(element) }}</td>
          </ng-container>
          <!-- Action Column -->
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef class="column-action">Action</th>
            <td mat-cell *matCellDef="let element" class="column-action">
              <button mat-icon-button color="primary" (click)="onEditInstrument(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="onDeleteInstrument(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
        </table>
      </div>
    }
  </div>
</div>
